import React from 'react';
import { treebenefits } from '../../../constants'; // Upewnij się, że masz treeBenefits w constants
import './TreeBenefits.css';

const TreeBenefits = () => {
    return (
        <section className='tree-benefits'>
            <div className='tree-benefits-container'>

                {/* --- LEWA STRONA (NAPIS) --- */}
                <div className='tree-benefits-left-panel'>
                    <div className='sticky-content'>
                        <h2 className='vertical-title'>INSRUKCJA DLA NAUCZYCIELI</h2>
                        <p className='vertical-subtitle'>
                        projekt „Słowa, które zostają”
                        Uczniowskie manifesty dla przyszłości
                        Fundacja Dwór Imielno
                        </p>
                    </div>
                </div>

                {/* --- PRAWA STRONA (GRID Z ELEMENTAMI) --- */}
                <div className='tree-benefits-grid'>
                    {treebenefits.map((item) => (
                        <div className="tree-benefit-item" key={item.id}>
                            <div className='icon'>{item.icon}</div>
                            <div className='text'>
                                <h3>{item.title}</h3>
                                <p>{item.description}</p>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default TreeBenefits;